import { resolveValue } from 'components/form/core/hooks/useField'
import { Calculation } from 'final-form-calculate'
import { MetaRoot } from 'util/metaPath'

import { AgendarConsultaSectionModel } from '../detail/soap/finalizacao/components/agendar-consulta/model-agendarConsultaAtendimento'

export const createAgendarConsultasCalculations = (name: MetaRoot<AgendarConsultaSectionModel>): Calculation[] => [
  createLotacaoAgendarConsultasCalculation(name),
  createIsForaUbsAgendarConsultasCalculation(name),
]

export const createLotacaoAgendarConsultasCalculation = <TFormState>(
  name: MetaRoot<AgendarConsultaSectionModel>
): Calculation => ({
  field: name.lotacao.absolutePath(),
  updates: {
    [name.data.absolutePath()]: (lotacaoValue: string, allValues: TFormState) => {
      const value = resolveValue(allValues, name)
      return lotacaoValue && value?.data
    },
    [name.isForaUbs.absolutePath()]: () => undefined,
  },
})

export const createIsForaUbsAgendarConsultasCalculation = (
  name: MetaRoot<AgendarConsultaSectionModel>
): Calculation => ({
  field: name.isForaUbs.absolutePath(),
  updates: {
    [name.localAtendimento.absolutePath()]: () => undefined,
  },
})
